import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import SEO from '../common/SEO';
import Layout from '../common/Layout';
import Separator from '../elements/separator/Separator';
import CaseStudyCard from '../elements/caseStudy/CaseStudyCard';
import caseStudies from '../data/caseStudies';

const CaseStudies = () => {
    return (
        <>
            <SEO title="Case Studies — Outlier Engineering Group" />
            <Layout>
                {/* Hero */}
                <div style={{ padding: '80px 0 60px', textAlign: 'center' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <span style={{
                                    display: 'inline-block',
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    letterSpacing: '0.15em',
                                    textTransform: 'uppercase',
                                    color: 'var(--color-primary)',
                                    marginBottom: '20px',
                                }}>
                                    Case Studies
                                </span>
                                <h1 style={{
                                    fontSize: 'clamp(2.4rem, 5vw, 3.8rem)',
                                    fontWeight: 800,
                                    lineHeight: 1.15,
                                    color: 'var(--color-heading)',
                                    margin: '0 0 24px 0',
                                }}>
                                    Built, deployed,<br />and operating.
                                </h1>
                                <p style={{
                                    fontSize: '18px',
                                    lineHeight: 1.7,
                                    color: 'var(--color-body)',
                                    maxWidth: '520px',
                                    margin: '0 auto',
                                }}>
                                    Recent projects across rail signaling, embedded engineering, and industrial systems.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <Separator />

                {/* Cards grid */}
                <div style={{ padding: '70px 0' }}>
                    <div className="container">
                        <div className="row" style={{ margin: '0 -12px' }}>
                            {caseStudies.map((study) => (
                                <div
                                    key={study.slug}
                                    className="col-lg-4 col-md-6 col-sm-12"
                                    style={{ padding: '12px', display: 'flex' }}
                                >
                                    <CaseStudyCard study={study} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Separator />

                {/* Contact CTA */}
                <div style={{ padding: '80px 0', textAlign: 'center' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <h2 style={{
                                    fontSize: 'clamp(1.6rem, 3vw, 2.4rem)',
                                    fontWeight: 700,
                                    color: 'var(--color-heading)',
                                    marginBottom: '16px',
                                }}>
                                    Working on a similar problem?
                                </h2>
                                <p style={{
                                    fontSize: '16px',
                                    color: 'var(--color-body)',
                                    marginBottom: '36px',
                                }}>
                                    Tell us what you're building. We'll tell you whether we can help.
                                </p>
                                <Link
                                    className="btn-default btn-icon"
                                    to="/contact"
                                    style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                                >
                                    Get in touch <FiArrowRight />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default CaseStudies;
